import { render, staticRenderFns } from "./IBSInboundFor3rdParty.vue?vue&type=template&id=7f7e92cc&scoped=true"
import script from "./IBSInboundFor3rdParty.vue?vue&type=script&lang=js"
export * from "./IBSInboundFor3rdParty.vue?vue&type=script&lang=js"
import style0 from "./IBSInboundFor3rdParty.vue?vue&type=style&index=0&id=7f7e92cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7e92cc",
  null
  
)

export default component.exports